export const mockDataProfile = {
  imgSrc:
    "https://media.licdn.com/dms/image/C4E03AQHmzgTGmjptnQ/profile-displayphoto-shrink_200_200/0/1635617372445?e=2147483647&v=beta&t=EpugC9pXrVUP3e37wjVAb4biKNoecK-9rpibwbyaRtI",
};
